import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { SENTRY_URL } from 'config'
import SmoothScroll from 'smoothscroll-polyfill'

import { AdvancedRoutes, SimpleRoutes, EnterpriseRoutes } from './routes'

import 'react-flexbox-grid/dist/react-flexbox-grid.css'
import 'react-dates/lib/css/_datepicker.css'
import 'react-datetime/css/react-datetime.css'
import 'rc-tooltip/assets/bootstrap.css'

import './index.css'

// Smoothscroll polyfill
SmoothScroll.polyfill()

// Sentry
if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'localhost') {
  const sentryConfig = {
    name: process.env.ADENE_ENV
  }

  const Raven = require('raven-js')
  const LogRocket = require('logrocket')
  LogRocket.init('cau4dx/poupaenergia')

  Raven.setDataCallback(function (data) {
    data.extra.sessionURL = LogRocket.sessionURL
    return data
  })

  Raven.config(SENTRY_URL, sentryConfig).install()
}

// Render elements
const advanced = document.getElementById('adene-simulador-avancado')
const simple = document.getElementById('adene-simulador-simples')
const enterprise = document.getElementById('adene-simulador-empresarial')

// Renders the advanced simulator
if (advanced) {
  ReactDOM.render(
    <AdvancedRoutes />
    , advanced
  )

  if (module.hot) {
    module.hot.accept('./routes', () => {
      const Next = require('./routes').AdvancedRoutes
      ReactDOM.render(
        <Next />,
        advanced
      )
    })
  }
}

// Renders the simple simulator
if (simple) {
  ReactDOM.render(
    <SimpleRoutes />
    , simple
  )

  if (module.hot) {
    module.hot.accept('./routes', () => {
      const Next = require('./routes').SimpleRoutes
      ReactDOM.render(
        <Next />,
        simple
      )
    })
  }
}

// Renders the simple simulator
if (enterprise) {
  ReactDOM.render(
    <EnterpriseRoutes />
    , enterprise
  )

  if (module.hot) {
    module.hot.accept('./routes', () => {
      const Next = require('./routes').EnterpriseRoutes
      ReactDOM.render(
        <Next />,
        enterprise
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/index.js